import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { makeDriverIcon } from './mapIcons';
import DriverPopupContent from './DriverPopupContent';
import { isSeverelyLate } from '../../../utils/composeDriverRecords';

// Global-view layer: one pin per driver with a live position, nothing else —
// no route lines or stop markers (the Single-route view draws those). Plain
// function, not a hook, so it's testable without a component harness.
export default function buildDriverMarkers(
  drivers,
  { onViewRoute = null } = {},
) {
  return drivers
    .filter(
      (driver) =>
        Number.isFinite(driver.latitude) && Number.isFinite(driver.longitude),
    )
    .map((driver) => (
      <Marker
        key={driver.routeId}
        position={[driver.latitude, driver.longitude]}
        icon={makeDriverIcon(driver, {
          severe: isSeverelyLate(driver.etaDeltaMin),
        })}
        zIndexOffset={1000}
      >
        <Popup>
          <DriverPopupContent driver={driver} onViewRoute={onViewRoute} />
        </Popup>
      </Marker>
    ));
}
